(function () {
  const STORAGE_KEY = 'savedSize_men';
  const TIMEOUT = 8000;

  /**
   * Wait until size radio buttons are rendered
   */
  function waitForRadios(callback) {
    const start = Date.now();

    (function check() {
      const radios = document.querySelectorAll(
        'input[type="radio"][name="Size"], input[type="radio"][name="option1"]'
      );

      if (radios.length) {
        callback(radios);
        return;
      }

      if (Date.now() - start > TIMEOUT) return;

      requestAnimationFrame(check);
    })();
  }

  /**
   * Apply size selection safely
   */
  function applySize(size) {
    if (!size) return;

    waitForRadios(radios => {
      const radio = [...radios].find(r => r.value === size);

      // Size no longer exists (out of stock / different product)
      if (!radio) {
        localStorage.removeItem(STORAGE_KEY);
        return;
      }

      // Prevent re-triggering
      if (radio.checked) return;

      radio.checked = true;
      const label = document.querySelector(`label[for="${radio.id}"]`) || radio.closest('label') || radio.nextElementSibling;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      radio.dispatchEvent(new Event('click', { bubbles: true }));
      label.click();

      console.log('[PDP] Applied saved men size:', size);
    });
  }

  /**
   * Initialize on PDP
   */
  function init() {
    const size = localStorage.getItem(STORAGE_KEY);

    // If PLP cleared filters, this key is removed → do nothing
    if (!size) return;

    applySize(size);
  }

  /**
   * Shopify lifecycle support
   */
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  /**
   * Manual debug helper (optional)
   */
  window.selectMenSize = function (size) {
    if (!size) return;
    localStorage.setItem(STORAGE_KEY, size);
    init();
  };
})();

